// src/api/class/classApi.js
import apiClient from '../index';

/**
 * Create a new class
 * @param {Object} classData - The data for the new class
 * @param {string} classData.className - Name of the class
 * @param {string} classData.sessionId - ID of the session
 * @param {string} classData.formStaffId - ID of the form staff/teacher
 * @returns {Promise<Object>} - Created class data
 */
export const createClass = async (classData) => {
  try {
    const response = await apiClient.post('/api/class/', classData);
    return response.data;
  } catch (error) {
    console.error('Error creating class:', error);
    throw error;
  }
};

/**
 * Get all classes
 * @returns {Promise<Array>} - List of classes
 */
export const getAllClasses = async () => {
  try {
    const response = await apiClient.get('/api/class/');
    return response.data;
  } catch (error) {
    console.error('Error fetching classes:', error);
    throw error;
  }
};

/**
 * Get a specific class by ID
 * @param {string} classId - Class ID
 * @returns {Promise<Object>} - Class data
 */
export const getClassById = async (classId) => {
  try {
    const response = await apiClient.get(`/api/class/${classId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching class ${classId}:`, error);
    throw error;
  }
};

/**
 * Update a class
 * @param {string} classId - Class ID
 * @param {Object} classData - Updated class data
 * @returns {Promise<Object>} - Updated class data
 */
export const updateClass = async (classId, classData) => {
  try {
    const response = await apiClient.put(`/api/class/${classId}`, classData);
    return response.data;
  } catch (error) {
    console.error(`Error updating class ${classId}:`, error);
    throw error;
  }
};

/**
 * Delete a class
 * @param {string} classId - Class ID
 * @returns {Promise<Object>} - Response data
 */
export const deleteClass = async (classId) => {
  try {
    const response = await apiClient.delete(`/api/class/${classId}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting class ${classId}:`, error);
    throw error;
  }
};